module.exports = __webpack_public_path__ + "media/src/images/arrow_right-6ddf057a78ba192b34f9bb05d9a126bf.png";